import { Store, AnyAction } from 'redux'
import * as jotai from 'jotai'

import * as api from '@owl-nest/api-client/latest'
import { createStore } from '@owl-nest/redux-wrapper'

import { Project } from './public/models/project'
import { AppState, RootState, makeReducer } from './reducers'
import { getMessages } from './public/utils/message'
import * as UFE from './UFE'
import * as fan from './reducers/fandom'
import { Level, SYNC } from '@owl-nest/redux-wrapper/src/messages/actions'
import { Message } from '@owl-nest/redux-wrapper/src/messages/reducer'
import * as services from '@owl-nest/services'

const store = jotai.getDefaultStore()

export function createApplicationStore(project: Project, token?: string): Store<RootState, AnyAction> {
  initSharedMessages(project)
  initSharedAuth()

  const defaultFollowers = [
    api.UserRole.Editor,
    api.UserRole.Fan,
    api.UserRole.Moderator,
    api.UserRole.Owner,
    api.UserRole.Supporter,
  ]
  const userIsAFollower = !!project.user_role && defaultFollowers.includes(project.user_role)

  return createStore<AppState>(makeReducer(project) as any, [], {
    application: {
      fandom: {
        ...fan.initialState,
        userIsAFollower,
      },
      project: { data: project, token },
    },
    // redux try to `DeepPartial` everything, and it does not play well with
    // `React.ReactNode` stored within messages.
    // As Roosevelt once said : "an any a day keep the typechecker away"
    messages: store.get(services.message.MESSAGES_ATOM) as any,
    user: {
      identity: store.get(services.user.AUTH_ATOM),
    },
  })
}

function initSharedMessages(project: Project) {
  const notifications = UFE.NOTIFICATIONS || []
  const initialMessages = notifications.map(
    (notification) =>
      ({
        message: notification.children,
        level: notification.tags as Level,
      }) as Message,
  )
  const messages = [...getMessages(project), ...initialMessages]

  store.set(services.message.MESSAGES_ATOM, { type: SYNC, state: messages })
}

function initSharedAuth() {
  const user = UFE.CURRENT_USER

  store.set(
    services.user.AUTH_ATOM,
    services.user.actions.sync(
      user.is_authenticated
        ? {
            type: 'loggedin',
            authenticatedUser: user,
            extraFields: [],
            isLoggingOut: false,
            isRefreshing: false,
          }
        : {
            type: 'unknown',
            isIdentifying: false,
          },
    ),
  )
}
